import React from 'react';
import { withRouter } from 'react-router-dom';
import { Formik } from 'formik';
import FormErrors from './FormErrors';
import TextArea from './TextArea';
import RadioButton from './RadioButton';
import Datepicker from './Datepicker';
import UserMultiSelect from './UserMultiSelect';
import FormInput from './FormInput';
import Dropdown from './Dropdown';
import FieldContainer from './FieldContainer';
import FieldError from './FieldError';
import CountrySelect from './CountrySelect';

import 'react-select/dist/react-select.css';
import './Dropdown.css';

const Form = ({ children, onSubmit, redirect, history, ...props }) => (
  <Formik
    {...props}
    onSubmit={(values, { setSubmitting, setErrors }) => {
      Promise.resolve(onSubmit(values))
        .then(() => {
          redirect ? history.replace(redirect) : setSubmitting(false);
        })
        .catch(error => {
          setSubmitting(false);
          setErrors({ form: error });
        })
    }}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        {children}
      </form>
    )}
  />
)

Form.displayName = 'Form'

Form.defaultProps = {
  validateOnBlur: false,
  validateOnChange: false
}

Form.Errors = FormErrors;
Form.FieldGroup = FieldContainer;
Form.FieldError = FieldError;
Form.Input = FormInput;
Form.TextArea = TextArea;
Form.Dropdown = Dropdown;
Form.RadioButton = RadioButton;
Form.Datepicker = Datepicker;
Form.UserMultiSelect = UserMultiSelect;
Form.CountrySelect = CountrySelect;

export default withRouter(Form);



// WEBPACK FOOTER //
// ./src/components/form/index.js